/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(["underscore"], function(_) {

/*
  subscript   ::= '[' string | number ']'
  pathelement ::= DOT ident | subscript
  path = (ident | subscript) { pathelement }
 */

/*
var RE_IDENT_START =  /^[\p{Lu}\p{Ll}\p{Lt}\p{Lm}\p{Lo}\p{NI}][\p{Lu}\p{Ll}\p{Lt}\p{Lm}\p{Lo}\p{NI}\p{Mn}\p{Mc}\p{Nd}\p{Pc}]*$/
var RE_IDENT_REST  =  /[\p{Lu}\p{Ll}\p{Lt}\p{Lm}\p{Lo}\p{NI}\p{Mn}\p{Mc}\p{Nd}\p{Pc}]/
var RE_SPACE = /\s/
*/
  
// ASCII is not quite correct 
// http://stackoverflow.com/questions/2008279/validate-a-javascript-function-name
  
var RE_IDENT = /^[A-Za-z_$][\/:A-Za-z0-9_$]*/
var RE_SPACE = /^\s+/
var RE_INT = /^\d+/

// a wrapper for returning idents that cannot be resolved
function Symbol(value) {
    this.value = value;
}


var JSONPathParser = function(str) {
    if (_.isNumber(str)) str = JSON.stringify(str);
    else if (!_.isString(str)) throw new Error("Path must be string!");
    this.str = str;
    this.pos = 0;
    this.cur = this._nextToken();
}

var EOF = 0;
var STRING = 1;
var IDENT = 3;
var INT  =  4;
var DOT  = '.'
var LBRACK = '[';
var RBRACK = ']';

function kindToString(tok) {
    switch (tok) {
        case EOF: return "EOF";
        case STRING: return "STRING";
        case IDENT: return "IDENT";
        case INT: return "INT";
        case DOT: return ".";
        case LBRACK: return "]";
        case RBRACK: return "[";
        default:
        throw new Error("Unkonwn token " + tok);
    }
}

JSONPathParser.prototype.parsePathElement = function (options) {
    var result = null;
    if (this.cur.kind == IDENT) {
        result = this.cur.value;
        this.nextToken();
        return result;
    }
    else if (this.cur.kind == LBRACK) {
        this.nextToken();
        if (this.cur.kind == IDENT && options && options.allowSymbolicPath) {
            result = new Symbol(this.cur.value);
        }
        else if (this.cur.kind == STRING ||
           this.cur.kind == INT) {
            result = this.cur.value;
        }
        else {
            throw new Error("Expected INT or STRING as member of subscript, got: " + kindToString(this.cur.kind));
        }
        
        this.nextToken();
        if (this.cur.kind != RBRACK) {
            throw new Error("Expected ], got: " + kindToString(this.cur.kind));
        }
        this.nextToken();
        return result;
    }
    else {
      throw new Error("Expected IDENT or [, got: " + kindToString(this.cur.kind));
    }
}


JSONPathParser.prototype.parse = function(options) {

    // a single STRING is allowed
    if (this.cur.kind == STRING || this.cur.kind == INT) {
      this.nextToken();
      if (this.cur.kind == EOF) {
        return [this.lastToken.value];
      }
      else {
        throw new Error("Unexpected token " + kindToString(this.cur.kind));
      }
    }
    if (this.cur.kind != IDENT && this.cur.kind != LBRACK ) {
        throw new Error("Unexpected token " + kindToString(this.cur.kind));
    }
    var elements = [];
    do {
        // console.log(kindToString(this.cur.kind));
        if (this.lastToken && this.cur.kind == IDENT && this.lastToken.kind == IDENT) {
            throw new Error(". or [ expected after IDENT token, got:" + kindToString(this.cur.kind));
        }
        this.lastToken = this.cur;
        
        elements.push(this.parsePathElement(options));
        
        if (this.cur.kind == DOT) {
            this.nextToken();
            if (this.cur.kind != IDENT) {
                throw new Error("IDENT expected after . token, got:" + kindToString(this.cur.kind));
            }
        }
        
    } while (this.cur.kind != EOF) ;
    return elements;
}

JSONPathParser.prototype.nextToken = function() {
    this.lastToken = this.cur;
    this.cur = this._nextToken();
    return this.cur;
}

JSONPathParser.prototype._nextToken = function()  {
    var match = this.str.match(RE_SPACE);
    if (match) {
        this.str = this.str.substring(match[0].length);
        this.pos += match[0].length;
    }

    if (this.str.length == 0) return {kind: EOF};

    match = this.str.match(RE_INT);
    if (match) {
        this.str = this.str.substring(match[0].length);
        this.pos += match[0].length;
        return {kind:INT, value: parseInt(match[0])}
    }
    match = this.str.match(RE_IDENT);
    if (match) {
        this.str = this.str.substring(match[0].length);
        this.pos += match[0].length;
        return {kind:IDENT, value: match[0]}
    }

    var ch = this.str.charAt(0);
    this.pos++;
    if (ch == LBRACK || ch == RBRACK || ch == DOT) {
        this.str = this.str.substring(1);
        return {kind: ch}
    }
    else if  (ch == '"' || ch == "'") {
        var i = 1;
        var escaped = false;
        var lexeme = ""
        for (; i < this.str.length; ++i) {
            var chi = this.str.charAt(i);
            if (chi == ch && !escaped) {
                this.str = this.str.substring(i+1);
                this.pos += i;
                return {kind: STRING, value: lexeme};
            }
            else if (chi == "\\" && !escaped)
                escaped = true;
            else if (escaped) {
                switch (chi) {
                    case "b": lexeme += "\b"; break
                    case "f": lexeme += "\f"; break;
                    case "n": lexeme += "\n"; break;
                    case "r": lexeme += "\r"; break;
                    case "t": lexeme += "\t"; break;
                    case "'": lexeme += "'"; break;
                    case '"': lexeme += '"'; break;
                    case "\\": lexeme += '\\'; break;
                    case "u":  {
                        var begin = i + 1;
                        if (this.str.length < begin + 4) {
                            throw new Error("Invalid escape sequence \\" + chi);
                        }
                        var charcode = parseInt(this.str.substring(begin,4, 16));
                        lexeme += String.fromCharCode(charcode);
                        i += 4;
                    }
                    break;
                    default:
                    throw new Error("Invalid escape sequence \\" + chi);
                }
            }
            else {
                lexeme += chi;
            }
        }
        throw new Error("Unterminated string literal " + this.str);
    }
    throw new Error("Unexpected token " + ch);
}

JSONPathParser.parse = function(path, options) {
  var parser = new JSONPathParser(path);
  return parser.parse(options);
}

return JSONPathParser;


})
